import { DriverRanking } from '../../models/client-ranking';

const normalizeCpf = (cpf: string): string => cpf.replace(/\D/g, '');

const normalizePlate = (plate: string): string => plate.trim().toUpperCase();

/** Lowercase + remove diacríticos (NFD) para busca acento-insensível. */
const normalizeSearchText = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const filterDriversByQuery = (
  drivers: DriverRanking[],
  query: string
): DriverRanking[] => {
  const trimmed = query.trim();
  if (!trimmed) return drivers;

  const qLower = normalizeSearchText(trimmed);
  const qDigits = normalizeCpf(trimmed);
  const qPlate = normalizePlate(trimmed);

  return drivers.filter((driver) => {
    const nameMatch =
      driver.driverName &&
      normalizeSearchText(driver.driverName).includes(qLower);
    const cpfMatch = qDigits.length > 0 && normalizeCpf(driver.driverCpf).includes(qDigits);
    const plateMatch =
      driver.plate &&
      normalizePlate(driver.plate).includes(qPlate);

    return Boolean(nameMatch || cpfMatch || plateMatch);
  });
};
